import { render } from "./Dashboard.vue?vue&type=template&id=7f5185b4&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=7f5185b4&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=7f5185b4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5185b4"]])

export default __exports__